import { Paper, Typography, Stack, Chip, alpha } from "@mui/material";
import { IPublicEventDetails } from "../../../interfaces/IPublicEventDetails";

export default function EventOverview({ event, primaryColor = '#493193', secondaryColor = '#2fadd8' }: { event: IPublicEventDetails; primaryColor?: string; secondaryColor?: string }) {
    return (
        <Paper
            elevation={2}
            sx={{
                p: { xs: 2, md: 4 },
                mb: { xs: 3, md: 4 },
                borderRadius: 3,
                border: `1px solid ${alpha(primaryColor, 0.1)}`,
                boxShadow: `0 4px 20px ${alpha(primaryColor, 0.06)}`,
            }}
        >
            <Typography
                variant="h5"
                gutterBottom
                sx={{
                    fontWeight: 700,
                    fontSize: { xs: "1.3rem", md: "1.5rem" },
                    background: `linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColor} 100%)`,
                    backgroundClip: 'text',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    mb: 3,
                }}
            >
                About This Event
            </Typography>
            {event.description?.split(/\n{1,}/).map((para, i) => (
                <Typography
                    key={i}
                    variant="body1"
                    component="p"
                    sx={{
                        mb: 2,
                        lineHeight: 1.7,
                        color: 'text.secondary',
                        wordBreak: 'break-word',
                        overflowWrap: 'anywhere',
                        whiteSpace: 'pre-wrap'
                    }}
                >
                    {para}
                </Typography>
            ))}
            <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap sx={{ mt: 3 }}>
                {event.tags.map((tag) => (
                    <Chip
                        key={tag}
                        label={tag}
                        sx={{
                            borderRadius: '50px',
                            fontWeight: 500,
                            bgcolor: alpha(primaryColor, 0.08),
                            color: primaryColor,
                            border: `1px solid ${alpha(primaryColor, 0.2)}`,
                            '&:hover': {
                                bgcolor: alpha(primaryColor, 0.12),
                            },
                        }}
                    />
                ))}
            </Stack>
        </Paper>
    );
}